import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.footer`
	display: flex;
	justify-content: space-between;
	padding: 1em;
	border-top: 1px solid #eaeaea;
`;

export const Footer: React.FC<{}> = () => (
	<Wrapper>
		<section></section>
	</Wrapper>
);
